import { just, nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import InlineTextField from '../components/InlineTextField';
import { TranslationsContext, translation } from '../../../../../../Translations';

interface Props {
  internalName: string;
  handleLearningCollectionInternalNameChange: (value: string) => void;
}

function InternalName({ internalName, handleLearningCollectionInternalNameChange }: Props) {
  return (
    <div className="min-w-0 w-full -mt-1">
      <TranslationsContext.Consumer>
        {(ts) => (
          <InlineTextField
            value={internalName}
            onChange={handleLearningCollectionInternalNameChange}
            emptyStateText={just('Add an internal name')}
            placeholder={just(translation('Internal name')(ts))}
            inputAriaLabel={just(translation('Internal name for this collection')(ts))}
            maxLength={just(255)}
            showMaxLengthError={just(true)}
            required={nothing()}
            showRequiredError={nothing()}
            editIntercomTarget={nothing()}
            emptyStateIntercomTarget={nothing()}
            className="border-none bg-transparent min-w-0 w-full"
            inputClassName="border-none focus:ring-0 p-0 cursor-pointer hover:cursor-text truncate"
            style={{ fontSize: 'var(--text-sm)' }}
          />
        )}
      </TranslationsContext.Consumer>
    </div>
  );
}

export default observer(InternalName);
